import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCtaSkeleton } from './TypeCta';
import type { TypeLegalTextSkeleton } from './TypeLegalText';
import type { TypeResponsiveImageSkeleton } from './TypeResponsiveImage';

export interface TypeBannerFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title: EntryFieldTypes.Symbol;
    subtitle?: EntryFieldTypes.Symbol;
    description?: EntryFieldTypes.RichText;
    primaryCta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
    secondaryCta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
    tertiaryCta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
    video?: EntryFieldTypes.AssetLink;
    pauseVideoAriaLabel?: EntryFieldTypes.Symbol;
    playVideoAriaLabel?: EntryFieldTypes.Symbol;
    videoPoster?: EntryFieldTypes.AssetLink;
    autoplayVideo?: EntryFieldTypes.Boolean;
    image?: EntryFieldTypes.EntryLink<TypeResponsiveImageSkeleton>;
    legal?: EntryFieldTypes.EntryLink<TypeLegalTextSkeleton>;
}

export type TypeBannerSkeleton = EntrySkeletonType<TypeBannerFields, 'banner'>;
export type TypeBanner<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBannerSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBanner<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBanner<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'banner';
}
